import React from 'react';

type SessionErrorModalProps = {
  isViewerTokenError: boolean;
  message: string;
  status?: number;
  redirectUrl?: string;
};

export default function SessionErrorModal({
  isViewerTokenError,
  message,
  status,
  redirectUrl,
}: SessionErrorModalProps) {
  const isAccountBlocked = message.toLowerCase().includes('blocked');
  const isAccessDenied = status === 403 && !isAccountBlocked;
  const title = isAccountBlocked
    ? 'Account Blocked'
    : isAccessDenied
    ? 'Access Denied'
    : isViewerTokenError
    ? 'Viewer Session Expired'
    : 'Application Session Expired';
  const modalMessage = isAccountBlocked
    ? '\nIf you believe this was an issue, please contact software@virtest.eu.'
    : isAccessDenied
    ? 'You are not registered or lack the required permissions. \nIf you believe this was an issue, please contact software@virtest.eu.'
    : `${message} ${
        isViewerTokenError
          ? 'Please go to browser and reselect the patient.'
          : 'Please log in again and reselect the patient.'
      }`;

  return (
    <div
      role="presentation"
      className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/60 px-4"
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="session-error-title"
        aria-describedby="session-error-message"
        className="w-full max-w-[400px] bg-white px-10 py-[30px] text-center text-[#2c3e50] shadow-2xl"
      >
        <h2
          id="session-error-title"
          className="mb-5 text-lg font-bold"
        >
          {title}
        </h2>
        <p
          id="session-error-message"
          className="mb-5 whitespace-pre-line text-lg"
        >
          {modalMessage}
        </p>
        <button
          type="button"
          className="rounded-[5px] border border-[#2c3e50] bg-[#34495e] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#2c3e50]"
          onClick={() => window.location.assign(redirectUrl || '/')}
        >
          {isViewerTokenError ? 'NAVIGATE TO BROWSER' : 'LOGIN'}
        </button>
      </div>
    </div>
  );
}
